module.exports = __webpack_public_path__ + "img/lensIcon.164c2b45.png";